import ReactFlagsSelect from 'react-flags-select'

import {
    countryToLanguage,
    getLanguageCode,
    languageToCountry,
    setLanguageCode,
} from './LanguageUtils'
import TranslateUtils from './TranslateUtils'
import i18n from './i18nConfig'

const FlagsSelectButton = () => {
    const {translateCommons, translateKeys, translateLanguage} =
        TranslateUtils()
    return (
        <div className="custom-flags-select">
            <ReactFlagsSelect
                className=""
                showOptionLabel={true}
                showSelectedLabel={true}
                placeholder={translateLanguage('Select a language')}
                countries={['US', 'GB', 'BG']}
                customLabels={{
                    US: translateLanguage('US - English'),
                    GB: translateLanguage('UK - English'),
                    BG: translateLanguage('Bulgarian'),
                }}
                selected={languageToCountry(getLanguageCode())}
                onSelect={code => {
                    setLanguageCode(countryToLanguage(code))
                    i18n.changeLanguage(countryToLanguage(code))
                }}
            />
        </div>
    )
}

export default FlagsSelectButton
